import { site, cta } from '../content.js'
import Icon from '../components/Icon.jsx'
import { useSignedIn, useMyVenue } from '../components/SignIn.jsx'

export default function Cta() {
  const signedIn = useSignedIn()
  const venue = useMyVenue(signedIn)
  return (
    <section className="cta" id="get-started">
      <div className="container cta-inner">
        <h2 className="display-sm">{cta.title}</h2>
        <ol className="cta-steps">
          {cta.steps.map((s, i) => <li key={s}><span>{i + 1}</span>{s}</li>)}
        </ol>
        {signedIn
          ? <a href={site.accountUrl} className="btn btn-grad">Go to {venue?.name || 'your venue'} <Icon name="arrow" size={18} /></a>
          : <a href={site.signupUrl} className="btn btn-grad">{cta.button} <Icon name="arrow" size={18} /></a>}
      </div>
    </section>
  )
}
